import { Field, Formik } from "formik";
import React, { useEffect } from "react";
import { useState } from "react";
import {
  FieldInput,
  FieldDropSide,
  SearchableList,
  FieldInputSSN,
} from "../../../components";
import {
  getFormattedSsn,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
} from "../../../utils";

const WithdrawalRequestPersonalInformationFields = (props) => {
  const { fields, filteredValues } = props;
  //   const [frequencyList, setFrequencyList] = useState([]);
  //   const { response: companies } = useRequest({
  //     method: getCompaniesList,
  //     payload: 1, //TenantId, HardCoding should be removed
  //     defaultResponse: [],
  //   });
  //   useDeepEffect(() => {
  //     if (values[fields.companyId]) {
  //       getPayrollFrequencies(values[fields.companyId])
  //         .then((response) => {
  //           setFrequencyList(response);
  //         })
  //         .catch((error) => {
  //           //Handle Error
  //         });
  //     }
  //   }, [values[fields.companyId]]);

  return (
    <Formik>
      <div>
        <p className="mt-20 plan-sub-heading">Personal Information</p>
        <div className="d-flex">
          <Field
            size="md"
            isRequired
            name={fields.firstName}
            label={"First Name"}
            type="text"
            autoComplete="off"
            value={filteredValues.firstName}
            //   onChange={handleChange}
            disabled={true}
            component={FieldInput}
          />
          &nbsp;&nbsp;
          <Field
            size="smd"
            name={fields.middleName}
            label={"Middle Name/Initial"}
            type="text"
            autoComplete="off"
            value={filteredValues.middleName}
            //   onChange={handleChange}
            disabled={true}
            component={FieldInput}
          />
          &nbsp;&nbsp;
          <Field
            size="md"
            isRequired
            name={fields.lastName}
            label={"Last Name"}
            type="text"
            autoComplete="off"
            value={filteredValues.lastName}
            //   onChange={handleChange}
            disabled={true}
            component={FieldInput}
          />
        </div>
        <Field
          size="md"
          isRequired
          name={fields.uniquePersonalIdentification}
          label={"Social Security Number"}
          type="text"
          autoComplete="off"
          value={getFormattedSsn(filteredValues.uniquePersonalIdentification)}
          // onChange={handleChange}
          disabled={true}
          component={FieldInputSSN}
          maxLength="11"
        />
        <Field
          size="md"
          isRequired
          name={fields.companyName}
          value={filteredValues.companyName}
          label="Company Name"
          disabled={true}
          component={FieldInput}
        />
        <Field
          size="md"
          name={fields.employeeNumber}
          label={"Employee ID"}
          type="text"
          noLabelTransform
          autoComplete="off"
          value={filteredValues.employeeNumber}
          // onChange={handleChange}
          disabled={true}
          component={FieldInput}
        />
        <Field
          size="md"
          isRequired
          name={fields.payrollFrequency}
          value={filteredValues.payrollFrequency}
          label="Payroll Frequency"
          disabled={true}
          component={FieldInput}
        />
        <Field
          size="md"
          name={fields.gender}
          value={filteredValues.gender}
          // selectedValue={filteredValues[fields.gender]}
          label="Gender"
          options={toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.GENDER)}
          // popupContent={
          //   <SearchableList
          //     label="Select Gender"
          //     options={toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.GENDER)}
          //     onSelect={(value) => setFieldValue(fields.gender, value)}
          //     selectedValue={values[fields.gender]}
          //   />
          // }
          disabled={true}
          component={FieldDropSide}
        />
        <Field
          size="md"
          name={fields.maritalStatus}
          // value={values[fields.maritalStatus]}
          value={filteredValues.maritalStatus}
          label="Marital Status"
          placeholder="Select Marital Status"
          options={toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.MARITAL_STATUS)}
          // popupContent={
          //   <SearchableList
          //     label="Select Marital Status"
          //     options={toOptionValuesFromMapper(
          //       OPTIONS_DATA_MAPPER.MARITAL_STATUS
          //     )}
          //     onSelect={(value) => setFieldValue(fields.maritalStatus, value)}
          //     selectedValue={values[fields.maritalStatus]}
          //   />
          // }
          disabled={true}
          component={FieldDropSide}
        />
      </div>
    </Formik>
  );
};

export default WithdrawalRequestPersonalInformationFields;
